import { EMPTY_STRING } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import * as Yup from 'yup';
import { useSaveProfile } from '../../hooks';
import { useUpdateSettings } from '../../hooks/use-update-settings.hook';
import { useUserProfileQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';

export type PronounsFormType = {
  pronouns: string;
};
export const usePronounsForm = () => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettings();
  const me = useCurrentuser();
  const { data: profile } = useUserProfileQuery(me.id, { suspense: true });
  const saveProfile = useSaveProfile();

  const pronounsFormik = () => {
    const initialValues: PronounsFormType = {
      pronouns: profile?.pronouns ?? EMPTY_STRING
    };

    const validationSchema = Yup.object({
      pronouns: Yup.string().max(64, l10n.validations.lengthMatches(1, 64))
    });

    const onSubmit = async (values: PronounsFormType) => {
      try {
        await saveProfile({
          pronouns: values.pronouns,
        });

        onFormSubmitSuccess();
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { pronounsFormik };
};
